// extracted by mini-css-extract-plugin
export default {"mainMini":"P1knJF0GrfDH5QX9_y4I","body":"xSFgkfjMESNtcM2nl1Wc","currentImage":"kOn8dTRzNyr90wxFhdUb"};